export default "__VITE_ASSET__CSXP$7sz__"